/**
 * @generated SignedSource<<fe6c461eddff305bafe5a99e38fd27c7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type PatchSystemConfigInput = {
  patch: any;
};
export type useSystemConfigMutationsPatchMutation$variables = {
  id: string;
  input: PatchSystemConfigInput;
};
export type useSystemConfigMutationsPatchMutation$data = {
  readonly patchSystemConfig: {
    readonly errors: ReadonlyArray<{
      readonly code: string | null | undefined;
      readonly fields: ReadonlyArray<string> | null | undefined;
      readonly message: string | null | undefined;
      readonly shortMessage: string | null | undefined;
    }>;
    readonly result: {
      readonly config: any | null | undefined;
      readonly id: string;
    } | null | undefined;
  };
};
export type useSystemConfigMutationsPatchMutation = {
  response: useSystemConfigMutationsPatchMutation$data;
  variables: useSystemConfigMutationsPatchMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      },
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "PatchSystemConfigResult",
    "kind": "LinkedField",
    "name": "patchSystemConfig",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "code",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "fields",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "shortMessage",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "System",
        "kind": "LinkedField",
        "name": "result",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "config",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useSystemConfigMutationsPatchMutation",
    "selections": (v1/*: any*/),
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useSystemConfigMutationsPatchMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "5f02353bf58e282e7029366f6c362043",
    "id": null,
    "metadata": {},
    "name": "useSystemConfigMutationsPatchMutation",
    "operationKind": "mutation",
    "text": "mutation useSystemConfigMutationsPatchMutation(\n  $id: ID!\n  $input: PatchSystemConfigInput!\n) {\n  patchSystemConfig(id: $id, input: $input) {\n    errors {\n      code\n      fields\n      message\n      shortMessage\n    }\n    result {\n      id\n      config\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "e2276ea263d511f8e42b485fef6c9553";

export default node;
